import "./userAccount.css"
import { useNavigate } from "react-router-dom";

function UserAccount() {
    const navigate = useNavigate()
    return (
        <div className="user-acc">
            <div className="user-acc-container">
                <p>
                    سلام سبحان عزیز
                    در صفحه حساب کاربری خود شما میتوانید سفارشات, اعتبارات و لیست علاقه‌مندی های خود را مشاهده کنید.
                    همچنین میتوانید آدرس ها خود را مدیریت کرده و اطلاعات فردی را تکمیل یا ویرایش کنید.
                </p>
                <button onClick={() => navigate("/profile/editUserInfo")}>ویرایش اطلاعات</button>
            </div>
        </div>
    )
}

export default UserAccount;